/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Grid, Segment, Form, Input,
  Button, Divider, Dimmer, Loader
} from "semantic-ui-react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { changeRouteAction } from "actions/changeActiveItemActions";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();

class ProtocolConfiguration extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      tag: "",
      isGSDDimmerActive: false,
      isResetLogDimmerActive: false,
      isResetStatisticsDimmerActive: false,
      numOfSuccessfullFilesSent: 0,
      isNtpModalOpen: false,
      isTagConfigDimmerActive: false,
    };
  }

  showResetLogDimmer = () => this.setState({ isResetLogDimmerActive: true });
  hideResetLogDimmer = () => this.setState({ isResetLogDimmerActive: false });

  showGSDDimmer = () => this.setState({ isGSDDimmerActive: true });
  hideGSDDimmer = () => this.setState({ isGSDDimmerActive: false });

  showResetStatisticsDimmer = () => this.setState({ isResetStatisticsDimmerActive: true });
  hideResetStatisticsDimmer = () => this.setState({ isResetStatisticsDimmerActive: false });

  showTagConfigDimmer = () => this.setState({ isTagConfigDimmerActive: true });
  hideTagConfigDimmer = () => this.setState({ isTagConfigDimmerActive: false });

  retrieveData = async () => {
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tag", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ tag: data.tag }));
  }

  sendGSDFiles = async () => {
    let input = document.getElementById("send-gsd-files-input");
    let notSentFilenames = [];

    if (input.files.length > 0) {

      document.getElementById("total-num-of-files").innerText = input.files.length;

      this.showGSDDimmer();

      for (let i = 0; i < input.files.length; i++) {
        let data = new FormData();
        data.append(input.files[i].name, input.files[i]);

        await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "sendGsd_POST", {
          method: "POST",
          body: data
        })
          .then(UtilsInstance.checkStatus)
          .then(() => {
            // If the file was sent successfully, increment the number of files sent and show it on the loading dimmer
            this.setState({ numOfSuccessfullFilesSent: this.state.numOfSuccessfullFilesSent + 1 }, () => {
              document.getElementById("num-of-successful-files-sent").innerText = this.state.numOfSuccessfullFilesSent;
            });
          })
          .catch(() => {
            // If there was a problem while sending the file, add the file name to an array
            // so it can be shown to the user later
            notSentFilenames.push(input.files[i].name);
          });
      }

      // If all the files have been sent, alert the user
      if (notSentFilenames.length === 0) {
        setTimeout(() => {
          alert(Strings.SEND_FILES_SUCCESS);
          this.hideGSDDimmer();
          this.setState({ numOfSuccessfullFilesSent: 0 }, () => {
            document.getElementById("num-of-successful-files-sent").innerText = 0;
          });
        }, 500);
      }
      // If at least one file was not sent, alert the user, and show a list of all of the files
      // that were not sent
      else {
        let notSentFilenamesList = "";

        for (let i = 0; i < notSentFilenames.length; i++) {
          notSentFilenamesList = notSentFilenamesList.concat("\n• " + notSentFilenames[i]);
        }

        alert(Strings.THE_FOLLOWING_FILES_COULD_NOT_BE_SENT + notSentFilenamesList);
        this.hideGSDDimmer();
        this.setState({ numOfSuccessfullFilesSent: 0 }, () => {
          document.getElementById("num-of-successful-files-sent").innerText = 0;
        });
      }
    }
    else {
      alert(Strings.SELECT_GSD_FLIE);
    }
  }

  cleanLog = () => {
    let data = JSON.stringify({
      reset: "True"
    });

    this.showResetLogDimmer();

    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "resetLog_POST/protocol", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data,
      mode: "cors"
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.CLEAN_LOG_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.CLEAN_LOG_FAILURE + Strings.REASON + error);
      })
      .finally(this.hideResetLogDimmer);
  }

  cleanStatistics = () => {
    let data = JSON.stringify({
      reset: "True"
    });

    this.showResetStatisticsDimmer();

    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "resetStatistics_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data,
      mode: "cors"
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.CLEAN_STATISTICS_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.CLEAN_STATISTICS_FAILURE + Strings.REASON + error);
      })
      .finally(this.hideResetStatisticsDimmer);
  }

  handleTagChange = (e, { value }) => {
    this.setState({ tag: value });
  }

  alterTags = () => {
    this.props.onChangeRoute(this.props.currGenConfigComponent, "tags");
  }

  editDiagnostic = () => {
    this.props.onChangeRoute(this.props.currGenConfigComponent, "diagnostic");
  }


  sendTag = () => {
    this.showTagConfigDimmer();

    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "tag_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({ tag: this.state.tag })
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.TAG_WAS_CHANGED_SUCCESSFULLY_PROTOCOL);
      })
      .catch((error) => {
        alert(Strings.TAG_CHANGE_FAILURE_PROTOCOL + Strings.REASON + error);
      })
      .finally(this.hideTagConfigDimmer);
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.retrieveData();
  }

  render() {
    const isResetLogDimmerActive = this.state.isResetLogDimmerActive;
    const isResetStatisticsDimmerActive = this.state.isResetStatisticsDimmerActive;
    const isTagConfigDimmerActive = this.state.isTagConfigDimmerActive;

    return (
      <div>
        <Grid columns={2} doubling>
          <Grid.Column>
            <Segment>
              <Divider horizontal>{Strings.TAG_CONFIG_PROTOCOL}</Divider>
              <Form style={formStyle} onSubmit={this.sendTag}>

                <Form.Field inline>
                  <label style={labelStyle}>{Strings.TAG}</label>
                  <Input style={inputStyle}
                    placeholder='Rede de teste'
                    value={this.state.tag}
                    onChange={this.handleTagChange} />
                </Form.Field>

                <Button color="teal" type="submit" >{Strings.SETUP}</Button>
              </Form>
              <Dimmer active={isTagConfigDimmerActive} >
                <Loader>{Strings.SEND_CONFIG_WAITING}</Loader>
              </Dimmer>
            </Segment>

            <Grid columns={1} doubling>
              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.TAGS}</Divider>
                  <Button color="teal" onClick={this.alterTags}>{Strings.EDIT}</Button>
                </Segment>
              </Grid.Column>
            </Grid>
          </Grid.Column>

          <Grid.Column>

            <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.DIAGNOSTIC}</Divider>
              <Button color="teal" onClick={this.editDiagnostic}>{Strings.EDIT}</Button>
            </Segment>

            <Grid columns={2} doubling>
              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.LOG}</Divider>
                  <Button color="teal" onClick={this.cleanLog}>{Strings.CLEAR}</Button>
                  <Dimmer active={isResetLogDimmerActive} >
                    <Loader>{Strings.WAITING}</Loader>
                  </Dimmer>
                </Segment>
              </Grid.Column>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.STATISTICS}</Divider>
                  <Button color="teal" onClick={this.cleanStatistics}>{Strings.CLEAR}</Button>
                  <Dimmer active={isResetStatisticsDimmerActive} >
                    <Loader>{Strings.WAITING}</Loader>
                  </Dimmer>
                </Segment>
              </Grid.Column>

            </Grid>

          </Grid.Column>
        </Grid >
      </div >
    );
  }
}

const mapActionsToProps = {
  onChangeRoute: changeRouteAction,
};

const mapStateToProps = state => ({
  currGenConfigComponent: state.configRoutes.currGenConfigComponent,
  currProtConfigComponent: state.configRoutes.currProtConfigComponent
});

const formStyle = {
  marginTop: "24px",
  textAlign: "center",
  width: "100%"
};

const updateSegmentStyle = {
  textAlign: "center"
};

const labelStyle = {
  width: "20%"
};

const inputStyle = {
  width: "70%"
};

export default connect(mapStateToProps, mapActionsToProps)(withRouter(ProtocolConfiguration));
